import { Lightbulb, ArrowRight } from "lucide-react";

export const StartupFailureTakeaway = () => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-xl p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="p-2 bg-primary/10 rounded-lg shrink-0">
          <Lightbulb className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
          <p className="text-muted-foreground mb-4">
            The most successful founders aren't the ones who do everything—they're the ones who build systems and teams that can operate without them. Delegation isn't about losing control; it's about multiplying your impact.
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <div className="flex items-center gap-2">
              <ArrowRight className="h-4 w-4 text-primary" />
              <span className="text-foreground font-medium">Hire for ownership, not just skills</span>
            </div>
            <div className="flex items-center gap-2">
              <ArrowRight className="h-4 w-4 text-primary" />
              <span className="text-foreground font-medium">Document processes before scaling</span>
            </div>
            <div className="flex items-center gap-2">
              <ArrowRight className="h-4 w-4 text-primary" />
              <span className="text-foreground font-medium">Trust but verify with metrics</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
